import { createContext, useContext } from 'react';
import type { Platform } from '../types/platform';

export interface ChatbotContextValue {
  account: Platform;
  setAccount: React.Dispatch<React.SetStateAction<Platform>>;
  refreshAccount: () => Promise<void>;
  /** Live tunnel URL fetched from svc-business-chatbot /worker/url on mount. Empty until resolved. */
  workerUrl: string;
  /** Short-lived JWT for direct worker calls (1-hour TTL). Empty until workerUrl is resolved. */
  jwtToken: string;
}

export const ChatbotContext = createContext<ChatbotContextValue | null>(null);

// Convenience hook — throws if used outside ChatbotDetail layout
export function useChatbot(): ChatbotContextValue {
  const ctx = useContext(ChatbotContext);
  if (!ctx) throw new Error('useChatbot must be used inside <ChatbotDetail>');
  return ctx;
}
